export default __webpack_public_path__ + "static/media/tooltip_black_icon.fb3d9136.svg";